import React, {useContext, useEffect, useState, Fragment} from 'react';
import { useNavigate } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';
import resourcesServices from '../services/resourcesServices';
import { errorMessage } from '../errorHandler';
import BotonVolver from '../components/BotonVolver';

const Usuarios = () => {
  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)
  const [renderHTML, setRenderHTML] = useState(false)
  const [usuarios, setUsuarios] = useState([])
  const [roles, setRoles] = useState([]);
  const [filtroRol, setFiltroRol] = useState('');
  const [header, setHeader] = useState([]);
  const [query, setQuery] = useState({
    query: ""
  });

  useEffect(() => {
    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if( authInformation.autenticado === true && authInformation.rol !== 'Obligado'){
      setRenderHTML(true)
      fetchUsuarios()
      fetchRoles()
    } else {
      setRenderHTML(false)
    }
  }, [authInformation]);

  useEffect(() => {
    if(filtroRol!==null){
      obtenerPagina()
    }
  }, [filtroRol]);


  const fetchUsuarios = async (sortBy='', q='', page=1, otro='') => {
    try {
      const data = await resourcesServices.obtenerResources('usuarios', sortBy, q, page, otro);

      if (page === 1) {
        setUsuarios(data.data);
      } else {
        setUsuarios([...usuarios, ...data.data]);
      }

      setHeader(data.headers);

    } catch (error) {
      errorMessage(error)
    }
  };

  const fetchRoles = async () => {
    try {
      const data = await resourcesServices.obtenerResources('usuarios/obtenerRoles');
      setRoles(data.data);

    } catch (error) {
      errorMessage(error)
    }
  };

  const obtenerPagina = async (page=1) => {
    if(filtroRol!==null){
      fetchUsuarios('', query, page, 'rol_id=' + filtroRol)
    } else {
      fetchUsuarios('', query, page, '')
    }
  };

  const abrirUsuario = (usuario, rol) => {
    navigate(`/usuarioForm/${usuario.id}/${rol}`);
  }

  const handleFormSubmit = (e) => {
    e.preventDefault()

    fetchUsuarios('', query, 1, '')
  }



  return (
    <div>
      <h1>Usuario <BotonVolver /></h1>
      {renderHTML && (
        <>
        Filtros:
        <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
          {
            roles.map((rol, index) => (
              <div key={index} className='ms-1'>
                <input
                  type="radio"
                  className="btn-check"
                  name={`radio${index}`}
                  id={`radio${index}`}
                  value={rol.id}
                  autoComplete="off"
                  checked={filtroRol === rol.id}
                  onChange={(e) => setFiltroRol(e.target.value)}
                  />
                <label className="btn btn-outline-primary" htmlFor={`radio${index}`}>{rol.nombre}</label>
              </div>
            ))
          }
        </div>

        <form className="row g-3 align-items-center mb-3" onSubmit={handleFormSubmit}>
            {/* <pre>{JSON.stringify(query, null, 2)}</pre> */}
            <div className="col">
              <label className="">Criterio de búsqueda</label>
              <input type="text" placeholder='Por nombre o email o usuario o documento u organismo' onChange={(e) => setQuery({...query, ["query"]:e.target.value})} className="form-control" id="staticEmail2" value={query.query || ''} />
            </div>
            <div className="col">
              <button type="submit" className="btn btn-primary mt-5">Buscar</button>
            </div>
        </form>

        <div className="card">
          <div className="card-body px-0 pb-2">
            <div className="table-responsive">
              <table className="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Nombre</th>
                    <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Documento</th>
                    <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Usuario</th>
                    <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha</th>
                  </tr>
                </thead>
                <tbody>
                  {usuarios && usuarios.map((usuario, index) => {
                    return (
                      <Fragment key={index}>
                        <tr className={!usuario.activo ? 'bg-warning bg-gradient' : ''}>
                          <td>
                            <b>{usuario.nombre} {usuario.apellido} {!usuario.activo && ' - INACTIVO - '}</b>

                            <div className="btn-group ms-5" role="group" aria-label="Basic example">
                              {
                                usuario.roles.map((rol, idx) => (
                                  <button key={idx} className='btn btn-primary' type="button" onClick={()=>abrirUsuario(usuario, rol.nombre)}>
                                      {rol.nombre==='Apoderado' ? 'Apoderado / Patrocinante' : rol.nombre}
                                      {rol.nombre==='Notificador' && usuario.es_supervisor && (
                                        ' (Supervisor)'
                                      )}
                                  </button>
                                ))
                              }
                            </div>
                          </td>
                          <td className="align-middle text-center text-sm">
                            {usuario.documento_identidad}
                          </td>
                          <td className="align-middle">
                            {usuario.usuario}
                          </td>
                          <td>
                          {usuario.fecha_alta}
                          </td>
                        </tr>
                      </Fragment>
                    )
                  })
                  }
                </tbody>
              </table>

              {
                header["total-pages"] !== header["current-page"] && (
                  <div className='p-3'>
                    <button onClick={()=>obtenerPagina(header["current-page"] + 1)} className='btn btn-success mt-3'>Ver más | {header["current-page"]} de {header["total-pages"]}</button>
                  </div>
                )
              }
            </div>
          </div>
        </div>

        </>
      )}
    </div>
  );
};

export default Usuarios;